var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { D as DefaultNodeSize, C as ClusterScale, s as showMSIOption, v as validateBasicInfo, a as validateSubCluster, g as getSynapseValidateMessage } from "../../../../../ComputeFormikSettingsUtils-baaa5d0e.js";
import _ from "lodash";
import { ComputeType } from "../../../../../models/ComputeAbstract.js";
import { AuthenticationType } from "../../../../constants/ComputeResource.constants.js";
const SparkComputeTypeDictionary = {
  // https://experimentation.visualstudio.com/Analysis%20and%20Experimentation/_git/AnE.ExP.Nuget?path=%2FAnE.ExP.Pipeline.ComputeManagementService.Contract%2Fsrc%2FAnE.ExP.Pipeline.ComputeManagementService.Contract%2FComputeType.cs
  [ComputeType.CosmosVC]: 1,
  [ComputeType.Synapse]: 2,
  [ComputeType.BlueshiftADLA]: 4,
  [ComputeType.CosmosADLA]: 6
};
const getSynapseResources = (synapseSubClusterList) => {
  let resources = [];
  if (synapseSubClusterList && synapseSubClusterList.length > 0) {
    resources = synapseSubClusterList.map((item) => {
      var _a, _b, _c;
      return {
        name: item.Name,
        developmentUrl: item.DevelopmentUrl,
        storageAccount: item.StorageAccount,
        storageContainer: item.StorageContainer,
        poolName: item.PoolName,
        nodeSize: item.NodeSize === DefaultNodeSize ? void 0 : item.NodeSize,
        minWorkers: item.ScaleType === ClusterScale.AutoScaling ? parseInt((_a = item.MinWorkers) != null ? _a : "1") : void 0,
        maxWorkers: item.ScaleType === ClusterScale.AutoScaling ? parseInt((_b = item.MaxWorkers) != null ? _b : "1") : void 0,
        fixedWorkers: item.ScaleType === ClusterScale.Fixed ? parseInt((_c = item.FixedWorkers) != null ? _c : "4") : void 0,
        maxConcurrency: parseInt(item.MaxConcurrency),
        scaleType: item.ScaleType,
        sparkVersion: item.SparkVersion
      };
    });
  }
  return resources;
};
const convertToComputePostParams = (props) => {
  let cosmosVC = {
    cluster: props.cluster,
    vcName: props.vcName,
    maxConcurrency: props.maxConcurrency
  };
  let synapsePool = {
    strategy: 0,
    resources: getSynapseResources(props.synapseSubClusterList)
  };
  let adlaBlueshift = {
    adlaAccountName: props.adlaAccountName,
    maxConcurrency: props.maxConcurrency,
    defaultStorageAccountName: props.defaultStorageAccountName
  };
  let adlaCosmos = {
    adlaAccountName: props.adlaAccountName,
    maxConcurrency: props.maxConcurrency
  };
  let authenticationInfo = {
    authenticationId: props.servicePrincipalName
  };
  let postParams = {
    workspaceId: props.workspaceId,
    name: props.name,
    description: "",
    type: !props.sparkComputeType ? 0 : SparkComputeTypeDictionary[props.sparkComputeType],
    owners: props.owners,
    cosmosVC: props.sparkComputeType === ComputeType.CosmosVC ? cosmosVC : void 0,
    synapsePool: props.sparkComputeType === ComputeType.Synapse ? synapsePool : void 0,
    blueshiftADLA: props.sparkComputeType === ComputeType.BlueshiftADLA ? adlaBlueshift : void 0,
    cosmosADLA: props.sparkComputeType === ComputeType.CosmosADLA ? adlaCosmos : void 0,
    authenticationInfo: [ComputeType.BlueshiftADLA, ComputeType.CosmosADLA, ComputeType.Synapse].some((type) => type === props.sparkComputeType) && (!props.authenticationType || props.authenticationType === AuthenticationType.ServicePrincipal) ? authenticationInfo : void 0,
    managedIdentityId: showMSIOption(props.workspaceId) && (!props.authenticationType || props.authenticationType === AuthenticationType.ManagedIdentity) ? props.managedIdentityId : void 0
  };
  return postParams;
};
const ComputeCreateFormSettings = {
  mapPropsToValues: (props) => {
    return {
      workspaceId: props.workspaceId,
      name: "",
      sparkComputeType: "",
      owners: [],
      synapseSubClusterList: [],
      cluster: "",
      vcName: "",
      maxConcurrency: "",
      defaultStorageAccountName: ""
    };
  },
  validate: (values, props) => {
    let errors = {};
    errors = validateBasicInfo(values, props);
    errors = validateSubCluster(values, errors);
    return errors;
  },
  validateOnChange: true,
  validateOnBlur: true,
  handleSubmit: (values, bag) => __async(void 0, null, function* () {
    bag.props.onSubmit && bag.props.onSubmit(values);
  })
};
const getSynapseInfo = (synapseSubClusterListDefault, validation) => {
  let validationErrors = [];
  if (validation && validation.errors) {
    validation.errors.forEach((item) => {
      if (item.errorPosition) {
        const Resources = item.errorPosition.match(/SynapsePool\.Resources\[\d+\]/g);
        if (Resources && Resources.length > 0) {
          const numbers = Resources[0].match(/\d+/g);
          if (numbers && numbers.length > 0) {
            const n = numbers[0];
            const pos = item.errorPosition.indexOf(Resources[0]) + Resources[0].length;
            if (pos + 1 < item.errorPosition.length) {
              const errorPath = item.errorPosition.substring(pos + 1);
              const errorPathArray = errorPath.split(".");
              const error = errorPathArray[errorPathArray.length - 1];
              validationErrors.push({
                postion: n,
                errorIndex: error,
                errorMsg: item.description
              });
            }
          }
        }
      }
    });
  }
  let result = [];
  if (synapseSubClusterListDefault && synapseSubClusterListDefault.length > 0) {
    result = synapseSubClusterListDefault.map((item, index) => {
      var _a, _b, _c, _d;
      let subCluster = {
        Name: item.name,
        DevelopmentUrl: item.developmentUrl,
        StorageAccount: item.storageAccount,
        StorageContainer: item.storageContainer,
        PoolName: item.poolName,
        MaxConcurrency: (_a = item.maxConcurrency) == null ? void 0 : _a.toString(),
        NodeSize: !item.nodeSize ? DefaultNodeSize : item.nodeSize,
        ScaleType: item.scaleType,
        MaxWorkers: (_b = item.maxWorkers) == null ? void 0 : _b.toString(),
        MinWorkers: (_c = item.minWorkers) == null ? void 0 : _c.toString(),
        FixedWorkers: (_d = item.fixedWorkers) == null ? void 0 : _d.toString(),
        SparkVersion: item.sparkVersion,
        required: {
          Name: getSynapseValidateMessage("Name", item.name),
          DevelopmentUrl: getSynapseValidateMessage("DevelopmentUrl", item.developmentUrl),
          StorageAccount: getSynapseValidateMessage("StorageAccount", item.storageAccount),
          StorageContainer: getSynapseValidateMessage("StorageContainer", item.storageContainer),
          PoolName: getSynapseValidateMessage("PoolName", item.poolName),
          MaxConcurrency: !!item.maxConcurrency ? "" : "Required",
          ScaleType: getSynapseValidateMessage("ScaleType", item.scaleType),
          FixedWorkers: !!item.fixedWorkers && item.scaleType === ClusterScale.Fixed ? "" : "Required",
          MinWorkers: !!item.minWorkers && item.scaleType === ClusterScale.AutoScaling ? "" : "Required",
          MaxWorkers: !!item.maxWorkers && item.scaleType === ClusterScale.AutoScaling ? "" : "Required",
          SparkVersion: getSynapseValidateMessage("SparkVersion", item.sparkVersion)
        }
      };
      _.each(validationErrors, (item2) => {
        if (index.toString() === item2.postion) {
          subCluster.required[item2.errorIndex] = item2.errorMsg;
        }
      });
      return subCluster;
    });
  }
  return result;
};
const ComputeEditFormSettings = {
  mapPropsToValues: (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _A, _B, _C, _D;
    const data = props.defaultCompute;
    return {
      name: data.name,
      sparkComputeType: (_a = data.config) == null ? void 0 : _a.type,
      owners: (_b = data.config) == null ? void 0 : _b.owners,
      synapseSubClusterList: getSynapseInfo((_e = (_d = (_c = props.defaultCompute) == null ? void 0 : _c.config) == null ? void 0 : _d.synapsePool) == null ? void 0 : _e.resources, data.validation),
      cluster: (_g = (_f = data.config) == null ? void 0 : _f.cosmosVC) == null ? void 0 : _g.cluster,
      vcName: (_i = (_h = data.config) == null ? void 0 : _h.cosmosVC) == null ? void 0 : _i.vcName,
      maxConcurrency: (_t = (_p = (_l = (_k = (_j = data.config) == null ? void 0 : _j.cosmosVC) == null ? void 0 : _k.maxConcurrency) == null ? void 0 : _l.toString()) != null ? _p : (_o = (_n = (_m = data.config) == null ? void 0 : _m.cosmosADLA) == null ? void 0 : _n.maxConcurrency) == null ? void 0 : _o.toString()) != null ? _t : (_s = (_r = (_q = data.config) == null ? void 0 : _q.blueshiftADLA) == null ? void 0 : _r.maxConcurrency) == null ? void 0 : _s.toString(),
      adlaAccountName: (_y = (_v = (_u = data.config) == null ? void 0 : _u.blueshiftADLA) == null ? void 0 : _v.adlaAccountName) != null ? _y : (_x = (_w = data.config) == null ? void 0 : _w.cosmosADLA) == null ? void 0 : _x.adlaAccountName,
      servicePrincipalName: (_A = (_z = data.config) == null ? void 0 : _z.authenticationInfo) == null ? void 0 : _A.authenticationId,
      defaultStorageAccountName: (_C = (_B = data.config) == null ? void 0 : _B.blueshiftADLA) == null ? void 0 : _C.defaultStorageAccountName,
      managedIdentityId: (_D = data.config) == null ? void 0 : _D.managedIdentityId
    };
  },
  validate: (values, props) => {
    let errors = {};
    errors = validateBasicInfo(values, props);
    errors = validateSubCluster(values, errors);
    return errors;
  },
  validateOnChange: true,
  validateOnBlur: true,
  handleSubmit: (values, bag) => __async(void 0, null, function* () {
    bag.props.savePanel && bag.props.savePanel(values);
  })
};
export {
  ComputeCreateFormSettings,
  ComputeEditFormSettings,
  SparkComputeTypeDictionary,
  convertToComputePostParams,
  getSynapseResources
};
//# sourceMappingURL=ComputeCreateFormSettings.js.map
